export const ColorsConfig = {
  primary: {
    light: '#22c0c5',
    main: '#25A0A4',
    dark: '#16797c',
  },
  secondary: {
    light: '#BE4FE4',
    main: '#ED54CD',
  },
  info: {
    main: '#56c0ea',
    dark: '#3a8cb1',
  },
  success: {
    main: '#5AEDC4',
  },
  warning: {
    main: '#ED5454',
  },
  error: {
    light: '#FEEFEF',
    main: '#DA1414',
    dark: '#9B0000',
  },

  grey: {
    50: '#FFFFFF',
    100: '#FCFCFD',
    200: '#F5F7FB',
    300: '#ECEDF1',
    400: '#ACB3BD',
    500: '#ABB2BC',
    600: '#AAB6CE',
    800: '#252427',
    900: '#000000',
  },

  text: {
    primary: '#252427',
  },

  actions: {
    disabledBackground: 'rgba(159, 165, 172, 0.5)',
    disabled: 'rgba(0, 0, 0, 0.38)',
    hover: '#F8F9FC',
  },

  background: { paper: '#FFFFFF', default: '#FCFCFD', neutral: '#FFFFFF' },
};

export const DarkColorsConfig = {
  primary: {
    main: '#755BE4',
  },
  secondary: {
    main: '#FFFFFF',
  },
  info: {
    light: '#EEF2FA',
    main: '#2E5AAC',
    dark: '#043184',
  },
  success: {
    light: '#EDF9F0',
    main: '#287D3C',
    dark: '#085A1B',
  },
  warning: {
    light: '#FFF4EC',
    main: '#b95000',
    dark: '#692D00',
  },
  error: {
    light: '#FEEFEF',
    main: '#DA1414',
    dark: '#9B0000',
  },

  grey: {
    50: '#FFFFFF',
    100: '#FCFCFD',
    200: '#F5F7FB',
    300: '#ECEDF1',
    400: '#ACB3BD',
    500: '#ABB2BC',
    600: '#AAB6CE',
    800: '#252427',
    900: '#000000',
  },

  text: {
    primary: '#FFFFFF',
  },

  actions: {
    disabledBackground: 'rgba(159, 165, 172, 0.5)',
    disabled: '#FFFFFF',
  },

  background: { paper: '#211F24', default: '#201E23', neutral: '#585959' },
};
